// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YuPkH","form":"styles_form__o7Ojp"};